import React from 'react';
import social_responsibility from '../../assests/img/social-responsibility.jpg';

const SocialResponsibility = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Social Responsibility</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Social Responsibility
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={social_responsibility} alt="social-responsibility" width="100%" />
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    We encourage pupils to understand that with opportunity comes responsibility, and we place great store by the values of tolerance, understanding and service. Within school, and from the very beginning, we’ll encourage pupils to take on roles of support and leadership. We aim to be in touch with the outside world. All characters, backgrounds and faiths are celebrated and welcome here. We aim to prepares pupils for a future of work and service in the modern, interconnected world.
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    Through our charitable initiatives, pupils will be actively encouraged to give off themselves in the local community and raise money for charity. These are an important part of increasing awareness among pupils of those who are less fortunate than themselves and an ideal way of helping pupils to appreciate that there is life outside their school.
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    Each pupil brings a unique approach to charity work, which influences the various forms of volunteering they choose to undertake. We aim to kindle a genuine desire among pupils and staff to engage in partnership work, and a commitment to sharing our expertise, energy and facilities for the benefit of the local and wider community. Supporting the community outside the school gates will provide an opportunity for pupils to gain valuable real-life experiences, develop empathy and acquire an understanding of the needs and challenges of others, while also helping to develop the skills necessary to make a worthwhile contribution to wider society. It’ll have a positive impact on our pupils’ wellbeing as well as a positive impact on the wider community.
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    Through our social programme we aim to build a community of “KaramVeers” who are guided by values like empathy and compassion, and an active desire and necessary experience to bring transformative change in the society.
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="spiritual-care-and-wellbeing" target="_self" className="submenu">
                                                        Spiritual care and Wellbeing
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="academic-life"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Academic Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="sporting-life" target="_self" className="submenu">
                                                        Sporting Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="co-curricular" className="submenu">
                                                        Co-curricular
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="social-responsibility" target="_self" className="submenu">
                                                        Social Responsibility
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="activities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Activities
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="amenities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Amenities
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button>
                    </div>
                </div>
            </div >
        </>
    )
}

export default SocialResponsibility;